import { Box, Link, SimplePaletteColorOptions } from "@mui/material";
import FacebookIcon from "assets/Icons/FacebookIcon";
import TwitterIcon from "assets/Icons/TwitterIcon";
import LinkedinIcon from "assets/Icons/LinkedinIcon";
import InstagramIcon from "assets/Icons/InstagramIcon";
import { PrivateLabel } from "typedef/PrivateLabel";

const socialMediaIcons = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
} as const;

interface CSocialMediaIconsProps {
  privateLabel?: PrivateLabel;
}

export const PLSocialMediaIcons = ({
  privateLabel,
}: CSocialMediaIconsProps) => {
  const socialMediaInformation =
    privateLabel?.borrowerPortalConfiguration?.customHomePageContent
      ?.socialMediaInformation || {};

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
    >
      {Object.entries(socialMediaInformation).map(([key, social]) => {
        const IconComponent =
          socialMediaIcons[key as keyof typeof socialMediaIcons];
        if (!social.url || !IconComponent) return null;

        const primaryColor = privateLabel?.pallete
          .primary as SimplePaletteColorOptions;

        return (
          <Link
            key={key}
            href={social.url}
            sx={{ textDecoration: "none", color: "inherit" }}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
          >
            <IconComponent fill={primaryColor.main} />
          </Link>
        );
      })}
    </Box>
  );
};
